/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DepartmentData model module.
 * @module model/DepartmentData
 * @version 1.0
 */
class DepartmentData {
    /**
     * Constructs a new <code>DepartmentData</code>.
     * @alias module:model/DepartmentData
     */
    constructor() { 
        
        DepartmentData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DepartmentData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DepartmentData} obj Optional instance to populate.
     * @return {module:model/DepartmentData} The populated <code>DepartmentData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DepartmentData();

            if (data.hasOwnProperty('departmentNo')) {
                obj['departmentNo'] = ApiClient.convertToType(data['departmentNo'], 'Number');
            }
            if (data.hasOwnProperty('departmentName')) {
                obj['departmentName'] = ApiClient.convertToType(data['departmentName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DepartmentData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DepartmentData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['departmentName'] && !(typeof data['departmentName'] === 'string' || data['departmentName'] instanceof String)) {
            throw new Error("Expected the field `departmentName` to be a primitive type in the JSON string but got " + data['departmentName']);
        }

        return true;
    }


}



/**
 * @member {Number} departmentNo
 */
DepartmentData.prototype['departmentNo'] = undefined;

/**
 * @member {String} departmentName
 */
DepartmentData.prototype['departmentName'] = undefined;






export default DepartmentData;

